import _ from 'lodash';
import React from 'react';
import postal from 'postal';
import toastr from 'toastr';
import Loading from '../../../shared/loading';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import ErrorBoundary from '../../../shared/error-boundary';
import Validator from '../../../shared/validator';
import { get, update } from '../../../services/lwadmin/score-weighting/score-weighting-service';

export default class ManageScoreWeightingsModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.save = this.save.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleMultiplierChange = this.handleMultiplierChange.bind(this);

    this.state = {
      scoreWeightings: [],
      validator: new Validator(),
    };
  }

  componentDidMount() {
    this.$overlay.on('click', () => this.dismiss());

    postal.subscribe({
      channel: 'lwadmin.trending.commands',
      topic: 'manage-score-weightings',
      callback: () => this.present(),
    });
  }

  handleMultiplierChange(event, weightingId) {
    const multiplier = event.target.value;

    this.setState(state => {
      const weighting = _.find(state.scoreWeightings, { id: weightingId });

      weighting.multiplier = multiplier;
      state.validator[`validateWeightingMultiplier${weightingId}`](state);

      return state;
    });
  }

  save(event) {
    event && event.preventDefault();

    this.setState(
      state => state.validator.validateForm(state),
      () => {
        if (!this.state.validator.formValid) return;

        this.loading.start();
        update(this.state.scoreWeightings)
          .then(() => {
            toastr.success('Score weightings have been updated. Trigger a recalc to effect the new weightings for all wires.');
            this.dismiss();
          })
          .catch(e => defaultOnErrorHandler(e, 'Error updating score weightings'))
          .finally(() => this.loading.stop());
      },
    );
  }

  cancel(event) {
    event && event.preventDefault();
    this.dismiss();
  }

  dismiss() {
    this.$overlay.fadeOut();
    this.$modal.fadeOut();
  }

  present() {
    this.$overlay.fadeIn();
    this.$modal.fadeIn();
    this.loading.start();

    get()
      .then(response => this.setState(state => {
        state.scoreWeightings = response.data.score_weightings;
        state.scoreWeightings.forEach(w => {
          state.validator.addRule(`weightingMultiplier${w.id}`, s => {
            const found = _.find(s.scoreWeightings, { id: w.id });
            return _.isNumber(+found.multiplier);
          });
        });
        return state;
      }))
      .catch(e => defaultOnErrorHandler(e, 'Error loading score weightings'))
      .finally(() => this.loading.stop());
  }

  render() {
    const getRowForWeighting = weighting => {
      const weightingMultiplierValid = this.state.validator[`weightingMultiplier${weighting.id}Valid`];

      return (
        <tr key={weighting.id} className={`form-group ${weightingMultiplierValid || 'has-error'}`}>
          <td>{weighting.score_type}</td>
          <td>{weighting.source}</td>
          <td>
            <input type="text" placeholder="Multiplier" onChange={e => this.handleMultiplierChange(e, weighting.id)} value={weighting.multiplier} />
            {weightingMultiplierValid || <p className="help-block">The multiplier must be numeric</p>}
          </td>
        </tr>
      );
    };

    return (
      <ErrorBoundary>
        <div
          ref={e => (this.$overlay = $(e))}
          className="modal-overlay manage-score-weightings-modal-overlay"
        />
        <div
          ref={e => (this.$modal = $(e))}
          className="modal modal-large manage-score-weightings-modal"
          tabIndex="-1"
          role="dialog"
        >
          <article>
            <header>
              <h4>Score weightings</h4>
            </header>
            <Loading ref={c => (this.loading = c)}>
              <section>
                <form onSubmit={this.save}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Score type</th>
                        <th>Source</th>
                        <th>Multiplier</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.scoreWeightings.map(getRowForWeighting)}
                    </tbody>
                  </table>
                </form>
              </section>
              <footer>
                <button type="button" className="btn btn-secondary" onClick={this.cancel}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.save}>Save</button>
              </footer>
            </Loading>
          </article>
        </div>
      </ErrorBoundary>
    );
  }
}
